<!-- 网站地图 -->
<template>
  <div class="link-map">
    <div class="title">网站地图</div>
    <div class="subs">
      <div
        :class="{ sub: true, active: $route.path == item.path }"
        v-for="item in map"
        :key="item.path"
      >
        <router-link :to="item.path">{{ item.name }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      map: [
        { name: "行业动态", path: "/industry" },
        { name: "政策法规", path: "/policy" },
        { name: "公示公告", path: "/notice" },
        { name: "行业标准", path: "/standard" },
        { name: "在线培训", path: "/train" },
        { name: "在线考试", path: "/exam" },
        { name: "证书查询", path: "/query" },
        { name: "关于我们", path: "/about" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: #fff;
  background: $theme;
  font-weight: bold;
  padding: 7px 10px;
  margin-bottom: 10px;
}
.subs {
  .sub {
    border-bottom: 1px dashed #7d7d7d;
    margin: 2px 0 5px;
    line-height: 36px;
    font-size: 12px;
    position: relative;
    text-align: center;

    &:hover {
      background-color: #fef0f0;
      border-color: $theme;
      color: $theme;
      cursor: pointer;

      &::after {
        border-left-color: $theme;
      }
    }

    &::after {
      content: "";
      display: block;
      width: 0px;
      height: 0px;
      border: 5px solid transparent;
      border-left-color: #7e7e7e;
      position: absolute;
      left: 0;
      top: 13px;
    }

    a {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .active {
    background-color: #fef0f0;
    border-color: $theme;
    color: $theme;
    cursor: pointer;

    &::after {
      border-left-color: $theme;
    }
  }
}
</style>
